import React, { FC } from 'react';
import { PublicTextBlock } from '../../text-image-block/PublicTextBlock';
import { PublicTextImageBlockContainer } from '../../text-image-block/PublicTextImageBlockContainer';
import styles from './home_text_image_block.module.scss';

type Data = {
  block_text: string;
  block_title: string;
  block_type: string;
  link_text: string;
  link: string;
  video: {
    url: string;
  };
};

type Props = {
  label: 'picture_right' | 'picture_left';
  data: Data;
};

export const HomeTextImageBlock: FC<Props> = ({ data, label }) => {
  if (label === 'picture_right') return <BlockWithPictureRight data={data} />;
  if (label === 'picture_left') return <BlockWithPictureLeft data={data} />;
  return null;
};

const BlockWithPictureRight: FC<{ data: Data }> = ({ data }) => (
  <PublicTextImageBlockContainer>
    <PublicTextBlock
      type={data.block_type}
      title={data.block_title}
      text={data.block_text}
      link={data.link}
      linkText={data.link_text}
      titleTag="h3"
    />
    <div className={styles.imageContainer}>
      <img className={styles.image} src={data.video.url} />
    </div>
  </PublicTextImageBlockContainer>
);

const BlockWithPictureLeft: FC<{ data: Data }> = ({ data }) => (
  <PublicTextImageBlockContainer>
    <div className={styles.imageContainer}>
      <img className={styles.image} src={data.video.url} />
    </div>

    <PublicTextBlock
      type={data.block_type}
      title={data.block_title}
      text={data.block_text}
      link={data.link}
      linkText={data.link_text}
      titleTag="h3"
    />
  </PublicTextImageBlockContainer>
);
